// extracted by mini-css-extract-plugin
module.exports = {"container":"Letters_container__3P2Yv","link":"Letters_link___Z2x_","flexbox":"Letters_flexbox__3Yshc"};